<template>
  <div class="manage-family-container">
    <div class="family-layout">
      <!-- Family Members List -->
      <div class="family-sidebar">
        <div class="sidebar-header">
          <h3 class="sidebar-title">Manage Family</h3>
        </div>
        
        <div class="family-list">
          <v-progress-circular
            v-if="loading"
            indeterminate
            color="primary"
            class="loading-spinner" />
          
          <div v-if="!loading && !hasDependents" class="no-dependents">
            <v-icon class="no-deps-icon">mdi-account-details</v-icon>
            <p class="no-deps-text">No dependents for the selected patient.</p>
          </div>
          
          <div v-if="!loading && hasDependents" class="dependents-list">
            <div 
              v-for="(item, i) in dependentList" 
              :key="i"
              @click="selectDependent(item)"
              class="dependent-item"
              :class="{ 'selected': form.id === item.id }">
              <v-avatar size="36" class="dependent-avatar">
                {{ getInitials(item.firstName, item.lastName) }}
              </v-avatar>
              <span class="dependent-name">{{ item.firstName + ' ' + item.lastName }}</span>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Family Information Form -->
      <div class="family-content">
        <div v-if="form && Object.keys(form).length" class="form-card">
          <h3 class="form-title">Family Information</h3>          
          <div class="modern-form">
            <div class="form-grid">
              <div class="form-row">
                <div class="form-group">
                  <v-text-field
                    v-model="form.firstName"
                    label="First Name"
                    class="line-input custom-filled"
                    dense
                    hide-details="auto" />
                </div>
                <div class="form-group">
                  <v-text-field
                    v-model="form.lastName"
                    label="Last Name"
                    class="line-input custom-filled"
                    dense
                    hide-details="auto" />
                </div>
              </div>
              
              <div class="form-row">
                <div class="form-group">
                  <LessBadBirthDatePicker
                    v-model="form.birthDate"
                    label="Date of Birth"
                    class="line-input"
                    dense />
                </div>
                <div class="form-group">
                  <v-text-field
                    v-model="form.email"
                    label="Email"
                    class="line-input custom-filled"
                    dense
                    hide-details="auto" />
                </div>
              </div>
              
              <div class="form-row">
                <div class="form-group">
                  <v-text-field
                    v-model="form.address1"
                    label="Address 1"
                    class="line-input custom-filled"
                    dense
                    hide-details="auto" />
                </div>
                <div class="form-group">
                  <v-text-field
                    v-model="form.address2"
                    label="Address 2"
                    class="line-input custom-filled"
                    dense
                    hide-details="auto" />
                </div>
              </div>
              
              <div class="form-row">
                <div class="form-group">
                  <v-text-field
                    v-model="form.city"
                    label="City"
                    class="line-input custom-filled"
                    dense
                    hide-details="auto" />
                </div>
                <div class="form-group">
                  <v-text-field
                    v-model="form.state"
                    label="State"
                    class="line-input custom-filled"
                    dense
                    hide-details="auto" />
                </div>
              </div>
              
              <div class="form-row">
                <div class="form-group">
                  <v-text-field
                    v-model="form.postalCode"
                    label="Zip"
                    class="line-input custom-filled"
                    dense
                    hide-details="auto" />
                </div>
              </div>
              
              <div class="form-row">
                <div class="form-group">
                  <v-text-field
                    v-model="form.homePhone"
                    label="Home Phone Number"
                    class="line-input custom-filled"
                    dense
                    hide-details="auto" />
                </div>
                <div class="form-group">
                  <v-text-field
                    v-model="form.workPhone"
                    label="Work Phone Number"
                    class="line-input custom-filled"
                    dense
                    hide-details="auto" />
                </div>
              </div>
              
              <div class="form-row">
                <div class="form-group">
                  <v-text-field
                    v-model="form.mobilePhone"
                    label="Cell Phone Number"
                    class="line-input custom-filled"
                    dense
                    hide-details="auto" />
                </div>
                <div class="form-group">
                  <v-select
                    :items="patientStatuses"
                    label="Patient Status"
                    v-model="form.status"
                    class="line-input custom-filled"
                    dense
                    hide-details="auto" />
                </div>
              </div>
            </div>
          <div class="form-actions">
            <v-btn
              class="btn-primary"
              @click="updateDependent"
              :loading="isSubmitting">
              Save
            </v-btn>
            <v-btn
              class="btn-secondary"
              :disabled="Object.keys(originalForm).length === 0"
              @click="cancelEditDependent">
              Cancel
            </v-btn>
          </div>
          </div>
        </div>
        
        <div v-else class="no-selection">
          <v-icon class="no-selection-icon">mdi-account-edit</v-icon>
          <p class="no-selection-text">Select a family member to edit their information</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LessBadBirthDatePicker from '../../components/LessBadBirthDatePicker';
import DataService from '../../../_services/DataService';

export default {
  name: 'updateProfile',
  components: {
    LessBadBirthDatePicker,
  },
  data() {
    return {
      modalDependentInfo: false,
      page: 0,
      sizes: [5, 10, 20, 50, 100, 200],
      size: 5,
      totalPages: 13,
      dependentList: [],
      dependents: [],
      hasDependents: false,
      loading: true,
      pageName: 'Update Profile',
      editIcon: 'mdi-pencil-outline',
      editDependent: {},
      patientStatuses: [
        {text: 'Patient', enum: 0, value: 'Patient'},
        {text: 'NonPatient', enum: 1, value: 'NonPatient'},
        {text: 'Inactive', enum: 2, value: 'Inactive'},
        {text: 'Archived', enum: 3, value: 'Archived'},
        {text: 'Deleted', enum: 4, value: 'Deleted'},
        {text: 'Deceased', enum: 5, value: 'Deceased'},
        {text: 'Prospective', enum: 6, value: 'Prospective'},
      ],
      form: {},
      originalForm: {},
      isSubmitting: false,
    };
  },
  computed: {},
  watch: {
    page: {
      async handler() {
        await this.getData();
      },
      deep: false,
    },
  },
  methods: {
    getInitials(firstName, lastName) {
      const first = firstName && firstName.length > 0 ? firstName.charAt(0) : '';
      const last = lastName && lastName.length > 0 ? lastName.charAt(0) : '';
      return first + last;
    },
    async handlesizeChange(size) {
      this.size = size;
      this.page = 1;
      await this.getData();
    },
    async cancelEditDependent() {
      this.form = { ...this.originalForm };
    },
    async updateDependent() {
      try {
        if (!this.form.id) {
          this.$root.$emit('raise_alert', {
            color: 'error',
            text: 'Please select a dependent',
          });
          return;
        }

        this.isSubmitting = true;
        const response = await DataService.updatePatientInfo(this.form.id, this.form);
        if (response.status == 200) {
          this.$root.$emit('raise_alert', {
            color: 'success',
            text: 'Family member updated successfully',
          });
          this.originalForm = {};
          this.modalDependentInfo = false;
        } else {
          this.$root.$emit('raise_alert', {
            color: 'error',
            text: response.data || 'Something went wrong',
          });
        }
      } catch (err) {
        this.$root.$emit('raise_alert', {
          color: 'error',
          text: 'Something went wrong',
        });
      } finally {
        this.isSubmitting = false;
      }
    },
    async getData() {
      try {
        this.loading = true;
        this.dependentList = [];
        this.dependents = [];
        let params = {};
        params['size'] = this.size;
        params['page'] = this.page;

        const response = await DataService.getPatientFamily();
        this.dependentList = response.data;
        this.hasDependents = response.data.length > 0;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$root.$emit('raise_alert', {
          color: 'info',
          text: 'There was an error getting dependents',
        });
      }
    },
    getTextStatus(statusId) {
      switch (statusId) {
      case 0:
        return 'Patient';
      case 1:
        return 'NonPatient';
      case 2:
        return 'Inactive';
      case 3:
        return 'Archived';
      case 4:
        return 'Deleted';
      case 5:
        return 'Deceased';
      case 6:
        return 'Prospective';
      default:
        return 'Patient';
      }
    },
    async selectDependent(item) {
      this.form = { ...item };
      this.originalForm = { ...item };
    },
  },
  created() {},
  async mounted() {
    await this.getData();
    // Auto-select first dependent if available
    if (this.dependentList.length > 0) {
      this.selectDependent(this.dependentList[0]);
    }
  },
};
</script>

<style lang="scss">
@import '@/scss/variables.scss';

.manage-family-container {
  padding: 36px 12px 12px 12px;
}

.family-layout {
  display: grid;
  grid-template-columns: 320px 1fr;
  gap: 24px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
}

.family-sidebar {
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: $shadow-md;
  border: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  
  .sidebar-header {
    padding: 24px 24px 16px 24px;
    border-bottom: 1px solid #e2e8f0;
    
    .sidebar-title {
      font-size: 18px;
      font-weight: 600;
      color: #2d3748;
      margin: 0;
      font-family: 'Inter', sans-serif;
    }
  }
}

.family-list {
  padding: 16px;
  
  .no-dependents {
    text-align: center;
    padding: 40px 16px;
    
    .no-deps-icon {
      font-size: 48px;
      color: #cbd5e0;
      margin-bottom: 12px;
    }
    
    .no-deps-text {
      color: #718096;
      margin: 0;
      font-size: 14px;
    }
  }
  
  .dependents-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .dependent-item {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    background-color: #f8fafc;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
      background-color: #edf2f7;
      border-color: #cbd5e0;
    }
    
    &.selected {
      background-color: #f0f9e8 !important;
      border-color: #B0D35E !important;
      
      .dependent-name {
        color: #414a5b !important;
        font-weight: 600 !important;
      }
    }
    
    .dependent-avatar {
      background-color: #133b54 !important;
      color: white !important;
      margin-right: 12px !important;
    }
    
    .dependent-name {
      font-weight: 500 !important;
      color: #1f2937 !important;
      font-size: 14px !important;
    }
  }
}

.family-content {
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: $shadow-md;
  border: 1px solid #e2e8f0;
  padding: 24px;
  
  .form-card {
    .form-title {
      font-size: 18px;
      font-weight: 600;
      color: #2d3748;
      margin: 0 0 24px 0;
      font-family: 'Inter', sans-serif;
    }
  }
  
  .no-selection {
    text-align: center;
    padding: 80px 24px;
    
    .no-selection-icon {
      font-size: 64px;
      color: #cbd5e0;
      margin-bottom: 16px;
    }
    
    .no-selection-text {
      color: #718096;
      margin: 0;
      font-size: 16px;
    }
  }
}
</style>
